/*  Shared  */
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

class Device {
    constructor() {
        this.requests = new Requests();
    }

    cancel = () => {
        this.requests.cancel();
    };

    getNumberOfDevicesCount = async ({
        count = true,
        excludeExpired = true,
        includeClients = true,
        name = '*',
        size = -1
    }) => {
        const params = {
            count,
            excludeExpired,
            includeClients,
            name,
            size
        };
        try {
            const response = await axios.get('/device', {
                cancelToken: this.requests.token(),
                params
            });
            const parsed = parseInt(response?.data?.data?.count, 10);
            if (Number.isNaN(parsed)) {
                return 0;
            }
            return parsed;
        } catch (e) {
            debug.e('Error getting Device Count', e);
            return null;
        }
    };
}

export default Device;
